// Central label maps and utilities.
export const ROLE_LABELS = {
  general_counsel: "General Counsel",
  attorney: "Attorney",
  legal_manager: "Director of Legal Team",   // display alias per Feb 2026 rename
  contract_analyst: "Contract Analyst",      // renamed from Paralegal
  compliance: "Compliance",
  records_management: "Records Management",
  department_director: "Business Owner",   // Phase 1 relabel (dept director key preserved)
  business_unit_rep: "Requester (BU Rep)",
  it_admin: "IT Admin",
  // Phase 1 additions
  purchasing: "Purchasing",
  readonly_auditor: "Read-Only Auditor",
  contract_manager: "Contract Manager",
  department_admin: "Department Admin",
};

// Convenience — permission check across primary + delegated roles.
export function hasRole(user, roles) {
  if (!user) return false;
  const all = new Set([user.role, ...(user.roles || [])]);
  return roles.some(r => all.has(r));
}

export const STAGE_LABELS = {
  unassigned: "Unassigned",
  analyst_working: "Analyst Working",
  attorney_review: "Attorney Review",
  gc_review: "GC Review",
  vendor_review: "Vendor Review",
  legal_approved: "Legal Approved",
  executed: "Executed",
  rework_requested: "Rework Requested",
  rejected: "Rejected",
};

export const STAGES_ORDER = [
  "unassigned",
  "analyst_working",
  "attorney_review",
  "gc_review",
  "vendor_review",
  "legal_approved",
  "executed",
];

export const CHECKLIST_ITEMS = [
  { key: "w9", label: "W9 (within 1 year)" },
  { key: "coi", label: "Certificate of Insurance" },
  { key: "sunbiz", label: "SunBiz Registration" },
  { key: "oig", label: "OIG Exclusions Search" },
  { key: "sam", label: "SAM.gov Search" },
  { key: "it_security", label: "IT Security Questionnaire" },
];

export const EXTERNAL_LINKS = {
  sunbiz: "https://search.sunbiz.org/Inquiry/CorporationSearch/ByName",
  oig: "https://exclusions.oig.hhs.gov/",
  sam: "https://sam.gov/search/",
};

export function currency(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

export function slaChip(status) {
  switch (status) {
    case "on_track": return { cls: "chip chip-ontrack", label: "On Track" };
    case "due_soon": return { cls: "chip chip-duesoon", label: "Due Soon" };
    case "overdue": return { cls: "chip chip-overdue", label: "Overdue" };
    case "completed": return { cls: "chip chip-completed", label: "Executed" };
    default: return { cls: "chip chip-draft", label: "—" };
  }
}

export function humanOverdue(days) {
  if (days <= 0) return "";
  if (days === 1) return "1 day overdue";
  if (days < 7) return `${days} days overdue`;
  if (days < 30) return `${Math.floor(days/7)} week${Math.floor(days/7) > 1 ? "s" : ""} overdue`;
  return `${Math.floor(days/30)} month${Math.floor(days/30) > 1 ? "s" : ""} overdue`;
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map(p => p[0]).slice(0,2).join("").toUpperCase();
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s/60)}m ago`;
  if (s < 86400) return `${Math.floor(s/3600)}h ago`;
  return `${Math.floor(s/86400)}d ago`;
}
